import React, { useState, useEffect } from 'react';
import { Tabs, Input, Button, Space, message, Upload, Image } from 'antd';
import { FaPlus, FaUpload } from 'react-icons/fa';
import { getImg } from '../../../Api/getImg';
import { FaXmark } from 'react-icons/fa6';

const { TextArea } = Input;

const ReportNoteTabs = ({
  isPrivate,
  onSubmit,
  editingFields,
  onClearEdit,
  photoIdPreview,
  setPhotoIdPreview,
  uploading,
  handleUpload,
  setPhotoRemoved
}) => {
  const [fields, setFields] = useState({
    diagnosis: '',
    medications: '',
    followUp: '',
    sessions: '',
    notes: '',
  });

  useEffect(() => {
    if (editingFields) {
      setFields(editingFields);
    }
  }, [editingFields]);

  const handleChange = (field) => (e) => {
    setFields((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleSubmit = () => {
    const isEmpty = Object.values(fields).every((val) => !val.trim());
    if (isEmpty) {
      message.warning('Please fill at least one field before submitting.');
      return;
    }

    onSubmit(fields);
    message.success('Note submitted successfully');
    setFields({ diagnosis: '', medications: '', followUp: '', sessions: '', notes: '' });

    if (onClearEdit) onClearEdit();
  };

  const tabItems = isPrivate
    ? [
        {
          key: 'followUp',
          label: 'Follow-Up',
          children: (
            <TextArea
              placeholder="Enter follow-up plan"
              value={fields.followUp}
              onChange={handleChange('followUp')}
              autoSize={{ minRows: 4 }}
            />
          ),
        },
      ]
    : [
        {
          key: 'diagnosis',
          label: 'Diagnosis',
          children: (
            <TextArea
              placeholder="Enter diagnosis"
              value={fields.diagnosis}
              onChange={handleChange('diagnosis')}
              autoSize={{ minRows: 4 }}
            />
          ),
        },
        {
          key: 'medications',
          label: 'Medications',
          children: (
            <TextArea
              placeholder="Enter medications"
              value={fields.medications}
              onChange={handleChange('medications')}
              autoSize={{ minRows: 4 }}
            />
          ),
        },
        {
          key: 'followUp',
          label: 'Follow-Up',
          children: (
            <TextArea
              placeholder="Enter follow-up plan"
              value={fields.followUp}
              onChange={handleChange('followUp')}
              autoSize={{ minRows: 4 }}
            />
          ),
        },
        {
          key: 'sessions',
          label: 'Sessions',
          children: (
            <TextArea
              placeholder="Enter session details"
              value={fields.sessions}
              onChange={handleChange('sessions')}
              autoSize={{ minRows: 4 }}
            />
          ),
        },
        {
          key: 'notes',
          label: 'Additional Notes',
          children: (
            <TextArea
              placeholder="Any additional notes"
              value={fields.notes}
              onChange={handleChange('notes')}
              autoSize={{ minRows: 4 }}
            />
          ),
        },
      ];

  return (
    <div>
      <Tabs defaultActiveKey={tabItems[0].key} tabPosition="top" items={tabItems} />
      <Space style={{ marginTop: 16, display: 'flex', flexWrap: 'wrap' }}>
        <Space>
          <Button className="bg-primary text-white" icon={<FaPlus />} onClick={handleSubmit}>
            {editingFields ? 'Update Note' : 'Add Note'}
          </Button>
          {editingFields && (
            <Button onClick={onClearEdit} danger>
              Cancel Edit
            </Button>
          )}
        </Space>

        {/* 📎 Image upload block */}
        <div>
          {photoIdPreview ? (
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <Image
                src={getImg(photoIdPreview)}
                alt="Preview"
                style={{ maxWidth: 120, maxHeight: 80, borderRadius: 4 }}
              />
              <Button
                size="small"
                shape="circle"
                danger
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  transform: 'translate(50%, -50%)',
                }}
                onClick={() => {
                  setPhotoIdPreview(null);
                  setPhotoRemoved(true);
                }}
              >
                <FaXmark />
              </Button>
            </div>
          ) : (
            <Upload
              name="file"
              showUploadList={false}
              accept=".jpg,.jpeg,.png"
              customRequest={handleUpload}
              disabled={uploading}
            >
              <Button className="text-primary" icon={<FaUpload />} loading={uploading}>
                Upload Image
              </Button>
            </Upload>
          )}
        </div>
      </Space>
    </div>
  );
};

export default ReportNoteTabs;
